// Item library evaluate codes for /roads-sewers/storm-sewers Weholite Attenuation
// build-up dev-mode display — mirrors prelimsMapping.ts's description -> code
// lookup pattern, but keyed off each row's `wh_<n>_<suffix>` id rather than its
// description text, since the description's supplier name (default "Weholite")
// is user-configurable via the tab's Supplier Text Type control and would
// otherwise stop matching once swapped.
//
// "Weholite carriage", "Fixed Price on Above" and "15% OHP on above" have no
// code and are intentionally left out of the map.

export interface StormWeholiteAttenuationEvaluateCodeItem {
  suffix: string;
  code: string;
}

export const WEHOLITE_ATTENUATION_EVALUATE_CODES: StormWeholiteAttenuationEvaluateCodeItem[] = [
  { suffix: 'excPit', code: 'APATT001' },
  { suffix: 'levelComp', code: 'ALP035' },
  { suffix: 'granBase', code: 'ALP017' },
  { suffix: 'supplyTank', code: 'SCSATT034' },
  { suffix: 'welding', code: 'SCSATT011' },
  { suffix: 'offload21T', code: 'ALPE010+L001B' },
  { suffix: 'offload2men', code: 'L001B' },
  { suffix: 'install1', code: 'ACL004' },
  { suffix: 'install2', code: 'ACL004' },
  { suffix: 'totalBed', code: 'GWALP050' },
  { suffix: 'asDug', code: 'GWALP034' },
  { suffix: 'stockpile', code: 'ALP040' },
  { suffix: 'foundCover', code: 'APATT008' },
  { suffix: 'coverSlab', code: 'AMHCS1200' },
  { suffix: 'seatingRings', code: 'CDRA0099' },
  { suffix: 'cf', code: 'AMHID400' },
];

export function findWeholiteAttenuationEvaluateCode(rowId: string): string | undefined {
  const suffix = rowId.match(/^wh_\d+_(.+)$/)?.[1];
  return WEHOLITE_ATTENUATION_EVALUATE_CODES.find((i) => i.suffix === suffix)?.code;
}
